var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{class:{'disabled': !_vm.report.can_update},on:{"click":_vm.updateSync}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item-content',_vm._g({},on),[_c('v-list-item-title',[_vm._v("Update From Quantum")])],1)]}}])},[_vm._v(_vm._s(_vm.tooltipText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }